<template>
  <div class="insurance_wrapper">
    <p>
      <span class="choose_plan"> Choose an Insurance Plan </span>
      <span class="optional"> (Optional) </span>
    </p>
    <div style="display: flex; flex-direction: column; gap: 0.9rem">
      <div
        v-for="(plan, index) in insurancePlans"
        :class="{
          insurance_container: true,
          selected: selectedPlan.plan === plan.plan,
        }"
        class="cursor-pointer"
        :key="index"
        @click="handleRadioChange(plan)"
      >
        <div class="insurance_header">
          <label class="custom-radio">
            <input
              type="radio"
              :name="plan.plan"
              :value="{plan: plan.plan }"
              :checked="selectedPlan.plan === plan.plan"
            />
            <span class="radio-button"></span>
          </label>
          <p class="price">{{ plan.amount }}</p>
        </div>
        <div class="insurance_innerContainer">
          <div class="insurance_details">
            <span class="plan_name"> {{ plan.plan }} </span>
            <span class="plan_description">
              {{ plan.description }}
            </span>
          </div>
          <img src="../../assets/images/shield.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="note" style="margin-top: 0.8rem">
      <img src="../../assets/images/octicon_alert-24.svg" alt="" />
      <span>
        <span style="font-weight: 600; font-size: 14px;"> {{ $t("note") }}: </span>
        <span style="font-weight: 500; font-size: 14px;">{{ $t("insurance_txt") }} </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Insurance",

  props: {
    insurancePlans: Array,
    insurancePlan: Object,
  },

  data() {
    return {
      selectedPlan: null,
    };
  },
  methods: {
    handleRadioChange(plan) {
      this.selectedPlan = plan;
      this.$emit("selected-plan", this.selectedPlan);
    },
  },
  watch: {
    insurancePlans: {
        handler: function handler(val) {
            if (val && val.length > 0) {
                this.selectedPlan = val[0];
                this.$emit("selected-plan", this.selectedPlan);
            }
        },
        immediate: true,
        deep: true
    }
  },
};
</script>


<style scoped>
.insurance_container {
  border: 1px solid rgba(178, 188, 202, 1);
  border-radius: 6px;
  padding: 0.8rem;
  max-width: 528px;
}

.insurance_container,
.insurance_innerContainer {
  display: flex;
  gap: 0.7rem;
}

.insurance_innerContainer {
  width: 400px;
  align-items: center;
  justify-content: space-between;
}

.insurance_wrapper p span.choose_plan {
  font-size: 16px;
  font-weight: 500;
}

.insurance_wrapper p span.optional,
.note {
  font-size: 12px;
  font-weight: 500;
  color: rgba(134, 147, 165, 1);
}

.note {
  display: flex;
  align-items: center;
  background-color: rgba(255, 224, 224, 1);
  border: 1px solid rgba(220, 48, 48, 1);
  color: rgba(220, 48, 48, 1);
  max-width: 529px;
  padding: 17px 16px 17px 16px;
  gap: 16px;
  border-radius: 8px;
}

.insurance_container .insurance_header {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  height: 20px;
  align-items: center;
}

.insurance_container .insurance_header .price {
  padding-top: 0.8rem;
  font-size: 16px;
  font-weight: 700;
}

.insurance_innerContainer .insurance_details {
  display: flex;
  flex-direction: column;
}

.insurance_innerContainer .insurance_details .plan_name {
  font-size: 14px;
  font-weight: 700;
  color: rgba(94, 106, 121, 1);
}

.insurance_innerContainer .insurance_details {
  font-size: 12px;
  font-weight: 400;
  color: rgba(94, 106, 121, 1);
}

.custom-radio input[type="radio"] {
  display: none;
}

.insurance_container.selected {
  border: 1px solid rgba(22, 96, 207, 1);
  background-color: rgb(225, 235, 249);
}

.custom-radio .radio-button {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid rgba(130, 130, 130, 1);
  background-color: rgba(255, 255, 255, 1);
  vertical-align: middle;
  position: relative;
  cursor: pointer;
}

.custom-radio input[type="radio"]:checked + .radio-button {
  background-color: rgba(33, 62, 122, 1);
  border: none;
}

.custom-radio input[type="radio"]:checked + .radio-button::after {
  content: "";
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  top: 4.5px;
  left: 4.5px;
}
</style>
